// @flow
// $FlowFixMe
import React, { useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import IconLabel from '../util/IconLabel';
import styles from './SearchTip.css';
import { commonMessages } from '../messages/Common';
import Cookies from 'js-cookie';
import { SEARCH_TIP_CLOSED_COOKIE_NAME } from '../../constants';

declare var __CAPACITOR__: boolean;

type Props = {
  intl: IntlShape,
};

const SearchTip = ({ intl }: Props) => {
  const [isTipClosed, setIsTipClosed] = useState(true);

  const closeTip = () => {
    Cookies.set(SEARCH_TIP_CLOSED_COOKIE_NAME, 'true');
    setIsTipClosed(true);
  };

  useEffect(() => {
    setIsTipClosed(Cookies.get(SEARCH_TIP_CLOSED_COOKIE_NAME) === 'true');
  }, []);

  if (isTipClosed) {
    return null;
  }

  return (
    <span className={styles.tip}>
      <IconLabel name="info" size="small" />
      <FormattedMessage
        id="search.tip"
        defaultMessage="For best results: search for an artist (e.g. 'Bach'), open the artist page, then search in Works (e.g. 'Air') or filter in Recordings (e.g. Soloists → Gould)."
      />
      <button
        className={styles.tipCloseButton}
        onClick={closeTip}
        aria-label={intl.formatMessage(commonMessages.close)}
      >
        <IconLabel name="close" size="small" />
      </button>
    </span>
  );
};

export default injectIntl(SearchTip);
